import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { db } from '../firebase/firebase';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { DEFAULT_APP_PRIMARY } from '../utils/branding';

const TeamSetupPanel = ({ onTeamsUpdated, onDone }) => {
  const { projectId } = useParams();
  const [companyName, setCompanyName] = useState('');
  const [teamRole, setTeamRole] = useState('');
  const [teamColor, setTeamColor] = useState(DEFAULT_APP_PRIMARY);
  const [teams, setTeams] = useState([]);

  const fetchTeams = useCallback(async () => {
    const teamSnapshot = await getDocs(collection(db, `projects/${projectId}/teams`));
    const teamList = teamSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setTeams(teamList);
    onTeamsUpdated(teamList);
  }, [projectId, onTeamsUpdated]);

  useEffect(() => {
    if (projectId) fetchTeams();
  }, [projectId, fetchTeams]);

  const handleAddTeam = async (e) => {
    e.preventDefault();
    if (!companyName || !teamRole) return;

    await addDoc(collection(db, `projects/${projectId}/teams`), {
      name: companyName.trim(),
      role: teamRole.trim(),
      color: teamColor,
      status: 'active', // All new teams start as active
      finishedAt: null,
      finishedBy: null,
      finishedByName: null
    });

    setCompanyName('');
    setTeamRole('');
    setTeamColor(DEFAULT_APP_PRIMARY);
    fetchTeams();
  };

  return (
    <div style={{ marginBottom: '32px' }}>
      <h2 style={{ fontSize: '18px', fontWeight: '600' }}>Add Teams Here</h2>
      <form onSubmit={handleAddTeam} style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
        <input
          type="text"
          placeholder="Company Name"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          required
          style={{ padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
        />
        <input
          type="text"
          placeholder="Role"
          value={teamRole}
          onChange={(e) => setTeamRole(e.target.value)}
          required
          style={{ padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
        />
        <input
          type="color"
          value={teamColor}
          onChange={(e) => setTeamColor(e.target.value)}
          style={{ width: '50px', height: '50px', border: 'none' }}
        />
        <button
          type="submit"
          style={{
            background: '#22c55e',
            color: '#fff',
            padding: '10px 16px',
            border: 'none',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#16a34a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#22c55e'}
        >
          <Plus size={18} />
        </button>
      </form>

      <ul style={{ padding: 0, listStyle: 'none' }}>
        {teams.map((team) => (
          <li key={team.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--branding-app-surface-panel-border)' }}>
            <span
              style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: team.color,
                borderRadius: '50%',
                marginRight: '8px',
              }}
            ></span>
            <strong>{team.name}</strong> — {team.role}
          </li>
        ))}
      </ul>

      <button
        onClick={onDone}
        style={{
          marginTop: '16px',
          backgroundColor: 'var(--branding-app-primary)',
          color: 'var(--branding-app-primary-fg)',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: '600',
        }}
      >
        Done
      </button>
    </div>
  );
};

export default TeamSetupPanel;